import React, { Component } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Parallax } from 'react-scroll-parallax';
import media from 'src/styles/media';

class ParallaxCard extends Component {
  state = {};

  static propTypes = {
    title: PropTypes.node,
    subtitle: PropTypes.node,
    learnMore: PropTypes.node,
    background: PropTypes.string,
    link: PropTypes.string,
  };

  static defaultProps = {
    title: '',
    subtitle: '',
    learnMore: 'Learn More',
    background: '',
    link: '/',
  };

  render() {
    const {
      title,
      subtitle,
      learnMore,
      background,
      link,
      parallax,
    } = this.props;
    return (
      <Parallax {...parallax}>
        <Root to={link}>
          <Background style={{ backgroundImage: `url(${background})` }} />
          <Content>
            <Subtitle>{subtitle}</Subtitle>
            <Title>{title}</Title>
            <LearnMore>{learnMore}</LearnMore>
          </Content>
        </Root>
      </Parallax>
    );
  }
}

const Root = styled(Link)`
  display: flex;
  background: #fff;
  margin-bottom: 75px;
  @media (max-width: ${media.sm}) {
    margin-bottom: 40px;
  }
`;

const Background = styled.div`
  width: 50%;
  height: 500px;
  background-size: cover;
  background-position: 50% 50%;
  @media (max-width: ${media.sm}) {
    height: 250px;
  }
`;

const Content = styled.div`
  width: 50%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 45px;
  padding-bottom: 60px;
  color: ${({ theme }) => theme.colorPrimary};
`;

const Title = styled.h3`
  font-family: ${({ theme }) => theme.fontHeader};
  font-size: 28px;
  text-transform: uppercase;
  letter-spacing: 1px;
  @media (max-width: ${media.sm}) {
    font-size: 18px;
  }
`;

const Subtitle = styled.h4`
  font-family: ${({ theme }) => theme.fontBold};
  font-size: 11px;
  letter-spacing: 1.8px;
  text-transform: uppercase;
`;

const LearnMore = styled.p`
  font-size: 11px;
  letter-spacing: 1.8px;
  text-transform: uppercase;
`;

export default ParallaxCard;



// WEBPACK FOOTER //
// ./src/pages/Home/elements/ParallaxCard.js